import React from "react"
import { Row, Col, Button } from "reactstrap"
import { connect } from 'react-redux';
import {Link, useLocation} from "react-router-dom"
import {
  Sparklines,
  SparklinesBars,
} from "react-sparklines"

const Breadcrumb = (props) => {

const itemLength = (props.breadcrumbItems || []).length || 1;
const location = useLocation();
const { fiche } = location.state || {};
  return (
    <Row>
      <Col sm={9}>
        <div className="page-title-box">

          <h4>{props.title}</h4>
          <ol className="breadcrumb m-0">
            {
              (props.breadcrumbItems || []).map((item, key) =>
                (key + 1) === itemLength ?
                  <li key={key} className="breadcrumb-item active">{item.title}</li>
                  : <li key={key} className="breadcrumb-item"><Link to="#">{item.title}</Link></li>
              )
            }
          </ol>
        </div>
      </Col>
      <Col sm={3}>
        <div className="page-title-box">
          {fiche ? (<Button className="btn btn-lg btn-primary" style={{ width: "100%" }} tag="button" onClick={()=>{props.onAddDemande()}}>Ajouter une demande </Button>): null}
        </div>
      </Col>
    </Row>
  )
}

const mapStatetoProps = state => {
  const Layout = state.Layout;
  const BreadcrumbData = state.Breadcrumb
  return { layoutType: Layout.layoutType, title: BreadcrumbData.title, breadcrumbItems: BreadcrumbData.breadcrumbItems };
};

export default connect(mapStatetoProps, {})(Breadcrumb);
